module.exports = __webpack_public_path__ + "img/news1.335a6752.png";